import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { connect } from "react-redux"
import * as React from "react"
import { Col, Row, Tabs } from "antd"
import { Router } from "../../../../server/router"
import { GLOBAL_FILTER_IDENTIFIER } from "../../../filters/reducer"
import { voidsReportAgendaMounted } from "./actions"
import ReportHeadingPanel from "../components/ReportHeadingPanel"
import type { VoidsLogReportItem } from "../../../../graphql/types"
import { expandAllIds } from "../../../../utils/general"
import type { VoidsReportTableItem } from "./VoidsSummaryReportTable"
import VoidsSummaryReportTable from "./VoidsSummaryReportTable"
import { getDataForVoidsLogsTable, getDataForVoidsSummaryTable } from "./selectors"
import VoidsLogReportTable from "./VoidsLogReportTable"
import { DateRangePickerDataWrapper } from "../components/DateRangePickerDataWrapper"

type Props = {
    tab: Maybe<string>
    voidsSummaryData: VoidsReportTableItem[]
    voidsLogData: VoidsLogReportItem[]
    onLoaded: () => void
}

export const VoidsReportTabsEnum = {
    Summary: "summary",
    Log: "log",
}

export type VoidsReportTabs = (typeof VoidsReportTabsEnum)[keyof typeof VoidsReportTabsEnum]

class VoidsReportTabsContainer extends React.PureComponent<Props> {
    componentDidMount() {
        this.props.onLoaded()
    }

    handleTabClicked = (key: string) => {
        Router.push(`/reports/voids/${key}`)
    }

    render() {
        return (
            <div id="sales-by-report-tabs">
                <Row>
                    <Col span={24}>
                        <Tabs
                            onTabClick={this.handleTabClicked}
                            className="sales-by-report-tabs"
                            // @ts-expect-error
                            activeKey={this.props.tab}>
                            <Tabs.TabPane tab="Summary" key="summary">
                                <ReportHeadingPanel
                                    showReportTitle={false}
                                    identifier="voidsSummary"
                                    headerText="Summary"
                                    showOrderStatusFilter={false}
                                    showOrderSourceFilter={false}
                                    haveData={true}
                                    showSearchFilter={false}
                                />
                                <VoidsSummaryReportTable
                                    expandedRowsIds={expandAllIds(this.props.voidsSummaryData)}
                                    showLoading={false}
                                    data={this.props.voidsSummaryData}
                                    // @ts-expect-error
                                    reportIdentifier="voidsSummary"
                                />
                            </Tabs.TabPane>

                            <Tabs.TabPane tab="Log" key="log">
                                <ReportHeadingPanel
                                    showReportTitle={false}
                                    identifier="voidsLog"
                                    headerText="Logs"
                                    showOrderStatusFilter={false}
                                    showOrderSourceFilter={false}
                                    haveData={true}
                                    showSearchFilter={false}
                                />
                                <VoidsLogReportTable data={this.props.voidsLogData} reportIdentifier="voidsLog" />
                            </Tabs.TabPane>
                        </Tabs>
                    </Col>
                    <div
                        style={{
                            right: "16px",
                            position: "absolute",
                            top: "6px",
                        }}>
                        <Row
                            type="flex"
                            justify="end"
                            style={{
                                flexWrap: "nowrap",
                            }}>
                            <DateRangePickerDataWrapper identifier={GLOBAL_FILTER_IDENTIFIER} />
                        </Row>
                    </div>
                </Row>
                <style jsx={true} global={true}>
                    {`
                        .sales-by-report-tabs .ant-tabs-bar {
                            margin-bottom: 0px;
                        }

                        .sales-by-report-tabs .ant-tabs-tab,
                        .sales-by-report-tabs .ant-tabs-tab-active {
                            font-size: 1rem;
                            font-weight: bold !important;
                        }
                    `}
                </style>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    voidsSummaryData: getDataForVoidsSummaryTable(state),
    voidsLogData: getDataForVoidsLogsTable(state),
})

const mapDispatchToProps = {
    onLoaded: voidsReportAgendaMounted,
}
export default connect<any, any, any>(mapStateToProps, mapDispatchToProps)(VoidsReportTabsContainer)
